import Stack from '@mui/material/Stack'
import styled from '@mui/material/styles/styled'

export const EntityDetailsContentWrapperStyled = styled(Stack, {
  name: 'DetailsContentWrapper',
})(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('lg')]: {
    maxWidth: '100%',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: 'calc(100% - 350px)',
  },
}))
